import { RemarkableEmbedded, defaultInputClassName } from "@hcss/remarkable";
import { useEffect } from "react";
import { useQueryParam, StringParam } from "use-query-params";
import { ErrorPage } from "./error-page";
import { parse } from "query-string";

const localStorageKey = "preRedirectQueryParams";

export const Comments = () => {
  const [threadKey, setThreadKey] = useQueryParam("threadKey", StringParam);
  const [smsMessageHeader, setSmsMessageHeader] = useQueryParam("smsMessageHeader", StringParam);

  useEffect(() => {
    const queryParams = window.localStorage[localStorageKey]
    if(!queryParams) {
      return;
    }
    const { threadKey: tk, smsMessageHeader: smh} = parse(queryParams);
    if(tk) {
      setThreadKey(tk as string);
    }
    if(smh) {
      setSmsMessageHeader(smh as string)
    }
    window.localStorage.removeItem(localStorageKey);
  },[setThreadKey, setSmsMessageHeader])

  if (!threadKey) return <ErrorPage />;

  return (
    <RemarkableEmbedded
      id="remarkable-embedded"
      componentsProps={{
        Form: {
          componentsProps: {
            FormInput: {
              MentionsInputProps: { suggestionsPortalHost: undefined },
            },
          },
        },
      }}
      sx={{
        [`&  .${defaultInputClassName}__suggestions`]: {
          maxHeight: {
            xs: "200px !important",
            sm: "max(200px, calc(100vh - 195px)) !important",
          },
        },
      }}
      threadKey={threadKey}
      smsMessageHeader={smsMessageHeader ? atob(smsMessageHeader) : undefined}
    />
  );
};
